/**
 * LoadingSpinner Component
 *
 * Reusable loading spinner with optional text
 */

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner = ({ size = 'md', text, fullScreen = false }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-2',
    lg: 'w-16 h-16 border-4',
  };

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className={`${sizeClasses[size]} border-sky-blue border-t-transparent rounded-full animate-spin`}
      />
      {text && (
        <p className="text-gray-600 dark:text-gray-400 text-sm">
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-soft-cream dark:bg-gray-950 flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};
